import { asNullableMeasure, asNullableSiValue, type Measure, type SiValue, type Stored } from "lab-testing-units";
import { WATER_CONTENT_MASS } from "./units";

export const FURTHER_DRYING_INPUT_FIELDS = ["dryingStartAt", "dryingEndAt", "drySoilContainerMass"] as const;

export type FurtherDryingInputField = (typeof FURTHER_DRYING_INPUT_FIELDS)[number];

export interface FurtherDryingContract {
  dryingStartAt: string | null;
  dryingEndAt: string | null;
  drySoilContainerMass: Measure | null;
  readonly totalDryMass: SiValue | null;
  readonly dryMassChangePercent: number | null;
}

export const asFurtherDryingContract = (stored: Stored<FurtherDryingContract>): FurtherDryingContract => ({
  ...stored,
  drySoilContainerMass: asNullableMeasure(stored?.drySoilContainerMass, WATER_CONTENT_MASS),
  totalDryMass: asNullableSiValue(stored?.totalDryMass, WATER_CONTENT_MASS),
});
